import React from 'react';

import { typography } from '@pray/shared/components/foundations';
import CardInputField from '@pray/shared/components/ui/InputField/CardInputField';
import InputField from '@pray/shared/components/ui/InputField/InputField';
import Text from '@pray/shared/components/ui/Text';

import styles from './CardPaymentForm.module.scss';

export default function CardPaymentForm({ form }) {
  return (
    <section className={styles.container}>
      <div className={styles.header}>
        <Text variant={typography.h2}>Payment</Text>
        <Text className={styles.subheader}>All transactions are secured and encrypted</Text>
      </div>

      <div className={styles.form}>
        <CardInputField
          label="Card number"
          error={form.errors.card}
          onChange={(event) => {
            form.setValue('card', event.value);
            form.setError('card', event.error?.message);
          }}
        />

        <InputField
          label="Name on card"
          name="name"
          aria-label="name on card"
          value={form.values.name}
          error={form.errors.name}
          onChange={form.handleChange}
        />
      </div>
    </section>
  );
}
